import React, { useState } from 'react'
import { Box, Drawer, IconButton } from '@mui/material'
import { Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material'
import TopbarContent from './components/TopbarContent'
import useStyles from './styles.js'

const Topbar = () => {
    const classes = useStyles()
    const [showTopbar, setShowTopbar] = useState(false)

    const toggleTopbar = () => {
        setShowTopbar(!showTopbar)
    }

    return (
        <Box className={classes['topbarContainer']}>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleTopbar}
                className={classes['sideMenuIcon']}
                sx={{
                    color: 'white',
                    background: '#013358',
                    height: '83px',
                    cursor: 'pointer',
                    padding: '10px 10px',
                    borderRadius: '0',
                    position: 'fixed',
                    zIndex: 1300,
                }}
            >
                {showTopbar ? (
                    <CloseIcon
                        className={classes['icon']}
                        sx={{
                            fontSize: '60px',
                        }}
                    />
                ) : (
                    <MenuIcon
                        className={classes['icon']}
                        sx={{
                            fontSize: '60px',
                        }}
                    />
                )}
            </IconButton>
            <Drawer
                anchor="top"
                open={showTopbar}
                onClose={toggleTopbar}
                className={classes[`topbar ${showTopbar && 'open'}`]}
            >
                <TopbarContent onClose={toggleTopbar} />
            </Drawer>
        </Box>
    )
}

export default Topbar
